import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";
import Hero from "@/components/home/Hero";
import SearchFilter from "@/components/home/SearchFilter";
import FeaturedProperties from "@/components/home/FeaturedProperties";
import Marquee from "@/components/Marquee";
import InvestmentWhy from "@/components/home/InvestmentWhy";
import Locations from "@/components/home/Locations";
import ResComm from "@/components/home/ResComm";
import About from "@/components/home/About";
import WhyChooseUs from "@/components/home/WhyChooseUs";
import HowItWorks from "@/components/home/HowItWorks";
import EnquirySection from "@/components/home/EnquirySection";
import FAQ from "@/components/home/FAQ";
import ContactSection from "@/components/home/ContactSection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => scrollToId(location.state.scrollTo), 400);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <main data-testid="home-page">
      <Hero />
      <SearchFilter />
      <FeaturedProperties />
      <Marquee />
      <InvestmentWhy />
      <Locations />
      <ResComm />
      <About />
      <WhyChooseUs />
      <HowItWorks />
      <EnquirySection />
      <FAQ />
      <ContactSection />
    </main>
  );
}
